import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/lib/motion";
import { SectionHeading } from "@/components/PageIntro";

const FAQS = [
  { q: "Ist FestivalPlan kostenlos?", a: "Ja. FestivalPlan startet vollständig kostenlos. Alle Kernfunktionen – Gruppen, Chat, Packliste, Fahrgemeinschaft, Kasse und Aufgaben – sind ohne Kosten nutzbar." },
  { q: "Braucht jeder einen Account?", a: "Für die volle Nutzung legt jedes Crew-Mitglied ein kostenloses Konto an. So sieht jeder seine Aufgaben, Ausgaben und Chats in Echtzeit." },
  { q: "Kann ich mehrere Festivals verwalten?", a: "Absolut. Du kannst beliebig viele Festivals gleichzeitig planen und pro Event eine eigene Crew, Packliste und Kasse führen." },
  { q: "Sind meine Daten sicher?", a: "Deine Daten werden verschlüsselt übertragen und DSGVO-konform in der EU gespeichert. Du kannst deine Daten jederzeit einsehen, berichtigen oder löschen." },
  { q: "Kann ich Push Benachrichtigungen aktivieren?", a: "Ja. Aktiviere Push-Benachrichtigungen, um an Aufgaben, neue Chat-Nachrichten und wichtige Termine erinnert zu werden – ganz nach deinen Einstellungen." },
  { q: "Wie funktioniert die Gruppenkasse?", a: "Jede Ausgabe wird eingetragen und automatisch auf die Crew aufgeteilt. FestivalPlan zeigt dir jederzeit, wer wie viel bezahlt hat und wer noch was schuldet." },
];

export function FaqList({ items, prefix = "faq-item", valuePrefix = "item" }) {
  return (
    <Accordion type="single" collapsible className="divide-y divide-white/10 border-y border-white/10">
      {items.map((f, i) => (
        <AccordionItem key={f.q} value={`${valuePrefix}-${i}`} data-testid={`${prefix}-${i}`} className="border-b-0">
          <AccordionTrigger className="py-5 text-left font-display text-base font-medium text-white hover:no-underline">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-5 text-sm leading-relaxed text-white/60">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

export default function Faq({ withHeading = true }) {
  return (
    <section id="faq" data-testid="faq-section" className="border-b border-white/10">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-5 py-20 lg:grid-cols-[1fr_1.6fr] lg:gap-20 lg:px-8 lg:py-24">
        {withHeading && (
          <Reveal>
            <SectionHeading eyebrow="FAQ" title="Häufige Fragen" lead="Die wichtigsten Antworten rund um FestivalPlan – kompakt an einem Ort." />
          </Reveal>
        )}
        <Reveal delay={0.05} className={withHeading ? "" : "lg:col-span-2"}>
          <FaqList items={FAQS} />
        </Reveal>
      </div>
    </section>
  );
}
